export class IntegrationRunTime {
    integrationRunTimeId?: string;
    lastRunTime?: Date;
    nextRunTime?: Date;
    lastDataSent?: Date;
    integrationId: string;
    importTypeId: number;
    importTypeDescription?: string;
    destinationEndpointId: number;
    destinationEndpointName?: string;
    destinationEndpointDescription?: string;
    fastFetchEnabled?: boolean;
    activePushBack?: boolean;
}
